declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../../../services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ActorService } from '../../../../services/actor.service';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { SaveMaterialBatchInfoRequest, SaveMaterialBatchRequest, GenericProcPostRequest, S_Methods, SaveMaterialDetailsInfoRequest, EditMaterialDetailsInfoRequest } from '../../../../../../../src/app/ncs/models/actor/actor';

@Component({
  selector: 'ngbeditmaterialdetails',
  templateUrl: './editmaterialdetails.modal.html',
  styleUrls: ['./editmaterialdetails.modal.scss']
})

export class NgbEditMaterialDetailsModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  public isRequesting: boolean;
  @Input() Description: string;
  @Input() MaterialSpec: number;
  @Input() HsnCode: string;
  @Input() GroupName: string;
  @Input() GroupCode: number;
  @Input() SaleUOM: string;
  @Input() TaxPercent: number;
  @Input() PurchaseUOM: string;

  public UpdatedDescription: string;
  public UpdatedMaterialSpec: number;
  public UpdatedHsnCode: string;
  public UpdatedGroupName: string;
  public UpdatedTaxPercent: number;
  public UpdatedSaleUOM: string;
  public UpdatedPurchaseUOM: string;

  //ExpiryDate: NgbDateStruct;
  public ApiResData: ApiResponseModel;
  CurrentEditMaterialDetailsInfoRequest: EditMaterialDetailsInfoRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {
    this.CurrentEditMaterialDetailsInfoRequest = new EditMaterialDetailsInfoRequest();
    this.CurrentEditMaterialDetailsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.UpdatedDescription = this.Description;
    this.UpdatedMaterialSpec = this.MaterialSpec;
    this.UpdatedHsnCode = this.HsnCode;    
    //this.UpdatedGroupName = this.GroupName;
    this.UpdatedTaxPercent = this.TaxPercent;
    this.UpdatedSaleUOM = this.SaleUOM;
    this.UpdatedPurchaseUOM = this.PurchaseUOM;
    this.MaterialGroupCode = this.GroupCode;
}

  SaveMaterial() {
    var saveReq = new EditMaterialDetailsInfoRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40330;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;

    saveReq.MaterialSpec = this.MaterialSpec;
    saveReq.MaterialName = this.UpdatedDescription;
    saveReq.SellingUnit = this.UpdatedSaleUOM;
    saveReq.PurchaseUnit = this.UpdatedPurchaseUOM;
    saveReq.HsnCode = this.UpdatedHsnCode;
    saveReq.TaxPercentage = this.UpdatedTaxPercent;
    saveReq.MaterialGroupCode = this.MaterialGroupCode;

    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40330;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  MaterialGroupCode: number = 0;
  public MaterialGroupName: string;
  onAssignedToActorCodesurgeon2(event: any) {

    if (event != null) {
      this.MaterialGroupName = event;
    }

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
